import { useEffect } from "react";
import { logout } from "../api/auth";
import { getStoredUser, setSessionNotice } from "../utils/session";
const STAFF_TIMEOUT_MS = 20 * 60 * 1000;
const WARNING_MS = 60 * 1000;

function getUser() {
  return getStoredUser();
}

async function logoutWithReason() {
    try {
        await logout();
    } finally {
        setSessionNotice("You were signed out after 20 minutes of inactivity. Sign in again to continue securely.");
        window.location.href = "/login";
    }
}

export default function SessionTimeout() {
  useEffect(() => {
    const user = getUser();

    if (!user) {
      return undefined;
    }

    const protectedRoles = ["platform_admin", "facility_admin", "admin", "attorney", "inmate"];

    if (!protectedRoles.includes(user.role)) {
      return undefined;
    }

    let warningTimer = null;
    let logoutTimer = null;

    const resetTimers = () => {
      window.clearTimeout(warningTimer);
      window.clearTimeout(logoutTimer);

      warningTimer = window.setTimeout(() => {
        window.alert("You will be signed out soon due to inactivity.");
      }, STAFF_TIMEOUT_MS - WARNING_MS);

      logoutTimer = window.setTimeout(() => {
        logoutWithReason();
      }, STAFF_TIMEOUT_MS);
    };

    const events = ["mousemove", "keydown", "click", "touchstart", "scroll"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimers, { passive: true });
    });

    resetTimers();

    return () => {
      window.clearTimeout(warningTimer);
      window.clearTimeout(logoutTimer);

      events.forEach((event) => {
        window.removeEventListener(event, resetTimers);
      });
    };
  }, []);

  return null;
}
